import { RootState } from 'store/reducers'

export const selectActiveForm = (store: RootState) => store.login.form
